import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=07676e10"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=07676e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports